export default __webpack_public_path__ + "static/media/fechaduras.292633e6.png";